import { render } from "./InterviewStart.vue?vue&type=template&id=4de4d97a"
import script from "./InterviewStart.vue?vue&type=script&lang=js"
export * from "./InterviewStart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__